import React, { Component } from "react";

export default class Settings extends Component {
  render() {
    return <div>Settings Page</div>;
  }
}



// WEBPACK FOOTER //
// ./src/customers/settings.js